import React, { useEffect } from 'react';
// import ErrorBoundary from '../../../common/ErrorBoundary';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { chunk } from '../../../common/utils';
import ContentCard from '../../../common/ContentCard';
import ConnectedChallenge from './ConnectedChallenge';
import { connectedChallengeRequested } from '../actions';
import {
    getConnectedChallenges,
    getConnectedChallengesLoading,
} from '../selectors';
import LoadingComponent from '../../../common/LoadingComponent';
import './styles.scss';
import { noop } from '../../../common/propTypes';

function ConnectedChallenges({
    challenge,
    connectedChallenges,
    fetchConnectedChallenges,
    connectedChallengesLoading,
}) {
    useEffect(() => {
        if (challenge.id) {
            fetchConnectedChallenges(challenge.id);
        }
    }, [challenge]);

    const mainContent = connectedChallengesLoading ? (
        connectedChallenges.length ? (
            <>
                {chunk(connectedChallenges, 3).map(
                    (chunkedChallenges, index) => (
                        <div className="row" key={index}>
                            {chunkedChallenges.map((currentChallenge) => (
                                <div
                                    key={currentChallenge.id}
                                    className="col-4"
                                >
                                    <ConnectedChallenge
                                        parentChallenge={challenge}
                                        startDate={currentChallenge.startDate}
                                        endDate={currentChallenge.endDate}
                                        thumbnail={currentChallenge.thumbnail}
                                        title={currentChallenge.title}
                                        id={currentChallenge.id}
                                        progress={currentChallenge.progress}
                                        pickups={currentChallenge.pickups}
                                        target={currentChallenge.target}
                                    />
                                </div>
                            ))}
                        </div>
                    ),
                )}
            </>
        ) : (
            'No Data Available'
        )
    ) : (
        <LoadingComponent isLoading={connectedChallengesLoading} />
    );
    return (
        <div className="content-box p-0">
            <ContentCard
                heading={'Connected Challenges'}
                subHeading={''}
                showDropDown={false}
                content={mainContent}
                className="card-orientation"
            />
        </div>
    );
}

ConnectedChallenges.propTypes = {
    challenge: PropTypes.object.isRequired,
    connectedChallenges: PropTypes.array,
    connectedChallengesLoading: PropTypes.bool,
    fetchConnectedChallenges: PropTypes.func,
};

ConnectedChallenges.defaultProps = {
    connectedChallenges: [],
    connectedChallengesLoading: false,
    fetchConnectedChallenges: noop,
};

const mapStateToProps = (state) => {
    return {
        connectedChallenges: getConnectedChallenges(state),
        connectedChallengesLoading: getConnectedChallengesLoading(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchConnectedChallenges: (challengeId) =>
            dispatch(connectedChallengeRequested(challengeId)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ConnectedChallenges);
